
class HoverTab extends HTMLElement {
    connectedCallback() {
       this.items = Array.from(this.querySelectorAll('.collection'));
       this.isAnimation = true;
       this._timer = null;
       this.items.forEach( item => {
            item.addEventListener("pointerenter", this.open.bind(this));
       })
    }
    disconnectedCallback() {
        if (this._timer) clearTimeout(this._timer);
    }
    open(e) {
        
        const { currentTarget } = e;
        if(currentTarget.classList.contains('active')) return;
        if(!this.isAnimation) return;
        this.isAnimation = false
        this.removeActive();
        currentTarget.classList.add('active');
        

        this._timer =  setTimeout(() => {
            this.isAnimation = true;
            this._timer = null;
        },300);
       
    }

    removeActive() {
        this.items.forEach(el => el.classList.remove('active'))
    }
}

customElements.define('hover-tab', HoverTab);